module.exports = __webpack_public_path__ + "media/images/flags/32/Kiribati-ff59abf8ee5df8d74005dd17d865416d.png";